import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';
import ProductWarrantyClaimForm from './ProductWarrantyClaimForm';
import { accountsSel, userDataSel } from 'src/store/modules/user';

const mapStateToProps = (state: any) => {
  return {
    userAccounts: accountsSel(state),
    userData: userDataSel(state)
  };
};

export const pureComponent = ProductWarrantyClaimForm;

export default connect(mapStateToProps)(withI18n()(ProductWarrantyClaimForm));
